import { useEffect, useState } from 'react'
import axios from 'axios'
import { useConfig } from '../../Providers/ConfigProvider';
import useDebounce from '../../Hooks/useDebounce';

var qs = require('qs');
export default function useLoadingContractors(query, pageNumber) {
  const { useDebounceWithStandardValueCheck } = useDebounce()
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)
  const [contractors, setContractors] = useState([])
  const [hasMore, setHasMore] = useState(false)
  const [resultNumber, setResultNumber] = useState(0)

  const { api } = useConfig()

  const debouncedQuery = useDebounceWithStandardValueCheck(query, 500)

  useEffect(() => {
    setContractors([])
    // if(query == ''){
    //   query = 'undefined'
    // }
  }, [debouncedQuery])

  useEffect(() => {
    setLoading(true)
    setError(false)
    let cancel

    var toke = "Bearer" + " " + localStorage.getItem('token');
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': toke
    }

    api.get(`/api/v1/Customer/GetCustomers`, {
      headers: headers,
      params: {
        query: debouncedQuery === '' ? 'undefined' : debouncedQuery,
        page: pageNumber,
      },
      paramsSerializer: params => {
        return qs.stringify(params);
      },
      cancelToken: new axios.CancelToken(c => (cancel = c)),
    })
      .then(res => {
        // let combined = []
        // if (authState.selectedCustomerObject) {
        //   combined = [authState.selectedCustomerObject, ...res.data.customers]
        // }
        // else {
        //   combined = [...res.data.customers]
        // }
        // setContractors(prev => {
        //   const all = [...prev, ...combined]
        //   // Usuwanie duplikatów po custId
        //   const unique = Array.from(
        //     new Map(all.map(item => [item.custId, item])).values()
        //   )
        //   return unique
        // });
        setContractors(prevProducts => [...prevProducts, ...res.data.customers]);
        setResultNumber(res.data.resultNumber);
        setHasMore(res.data.customers.length > 9);
        setLoading(false);
      })
      .catch(e => {
        if (axios.isCancel(e)) return;
        console.error(e); // Log any non-cancel errors
      });

    return () => cancel();
  }, [debouncedQuery, pageNumber])

  return {
    loading,
    error,
    contractors,
    hasMore,
    resultNumber
  }
}